import { MOVEMENT_LOGIN_PAGE } from './env';

export function loginRedirect(): void {
  const currentLocation: string = encodeURIComponent(window.location.href);
  window.location.assign(
    `${MOVEMENT_LOGIN_PAGE}?redirect_uri=${currentLocation}`,
  );
}
